<template>
  <v-row>
    <template v-if="!titleHidden">
      <v-col cols="12">
        <div class="d-flex">
          <div class="form-base__title">
            Реквизиты документа, подтверждающего полномочия представителя
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        Тип документа: Нотариально заверенная доверенность
      </v-col>
    </template>

    <v-col cols="8">
      <TextField
        v-model="v.regNumber.$model"
        :errorMessages="getValidationErrorText(v.regNumber)"
        :label="FieldLabel.NOTARY_DOCUMENT_REG_NUMBER"
      />
    </v-col>
    <v-col cols="4">
      <DateFieldCustom
        :label="FieldLabel.NOTARY_DOCUMENT_DOC_DATE"
        :value="v.docDate.$model"
        @change="v.docDate.$model = $event"
        :errorMessage="v.docDate"
        :max="new Date().toISOString()"
      />
    </v-col>

    <v-col cols="12">
      <AttachDocumentSingle
        :load-profile-document-type="DocumentType.NOTARY_POWER_ATTORNEY"
        :value="{
          file: v.file.$model,
          fileSig: v.fileSig.$model,
        }"
        :error-messages="getValidationErrorText(v.file)"
        @change="
          v.file.$model = $event.file;
          v.fileSig.$model = $event.fileSig;
        "
        @change-from-profile="
          v.regNumber.$model = $event.regNumber;
          v.docDate.$model = $event.docDate;
          v.file.$model = $event.file;
          v.fileSig.$model = $event.fileSig;
        "
      />
    </v-col>
  </v-row>
</template>

<script>
import { and, maxLength, required } from 'vuelidate/lib/validators';
import {
  DATE_FORMAT,
  DATE_FUTURE,
  DATE_PAST,
  getValidationErrorText,
} from '@/utils/validate';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import { DocumentType } from '@/types/services';
import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import TextField from '@/components/base/TextField';
import { FieldLabel } from '@/constants';

export const notaryDocumentValidation = {
  regNumber: {
    required,
    maxLength: maxLength(30),
  },
  docDate: {
    required,
    DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
  },
  file: {
    required,
  },
  fileSig: { required },
};

export const notaryDocumentModel = {
  type: DocumentType.NOTARY_POWER_ATTORNEY,
  regNumber: '',
  docDate: '',
  file: null,
  fileSig: null,
};

export default {
  name: 'NotaryDocument',
  components: {
    DateFieldCustom,
    AttachDocumentSingle,
    TextField,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
    titleHidden: {
      type: Boolean,
    },
  },
  data: () => ({
    FieldLabel,
    getValidationErrorText,
    DocumentType,
  }),
};
</script>
